var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-overlay',[_c('rkm-layout-body',{attrs:{"title":"Mapa de produção"}},[(_vm.loaded)?_c('rkm-layout-content',[_c('Form',{ref:"Form",attrs:{"data":{ form: _vm.form }}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }